import moment from "moment";
import { EngineerTaskOption } from "./engineerVisitTypes";

export function taskLabel(key: string, options: EngineerTaskOption[]): string {
  return options.find((o) => o.key === key)?.label ?? key;
}

export function taskLabels(keys: string[], options: EngineerTaskOption[]): string[] {
  return keys.map((k) => taskLabel(k, options));
}

/** Value for <input type="datetime-local"> in the browser's timezone. */
export function toDateTimeLocal(iso: string | null | undefined): string {
  const m = iso ? moment(iso) : moment();
  return (m.isValid() ? m : moment()).format("YYYY-MM-DDTHH:mm");
}

export function fromDateTimeLocal(value: string): string | null {
  const m = moment(value, "YYYY-MM-DDTHH:mm", true);
  return m.isValid() ? m.toISOString() : null;
}

export function formatVisitDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const m = moment(iso);
  return m.isValid() ? m.format("ddd DD/MM/YYYY HH:mm") : "—";
}
